export const TextboxTypes = {
	AUTOCOMPLETE: 'autocomplete',
	DATE: 'date',
	PASSWORD: 'password',
	TEXT: 'text',
	TIME: 'time',
};
